export enum EMarketingCenterColorSchemes {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  AQUAMARINE = 'light-blue',
  PURPLE = 'purple',
  PINK = 'pink',
  ORANGE = 'orange',
  BLACK = 'grey'
}

export type TMarketingCenterColorScheme = {
  primary: string;
  secondary: string;
};

export const MarketingCenterColorSchemeDictionary: Record<
  EMarketingCenterColorSchemes,
  TMarketingCenterColorScheme
> = {
  [EMarketingCenterColorSchemes.RED]: {
    primary: '#E51B1B',
    secondary: '#FF1E1E'
  },
  [EMarketingCenterColorSchemes.BLUE]: {
    primary: '#3E24D6',
    secondary: '#1B86E5'
  },
  [EMarketingCenterColorSchemes.GREEN]: {
    primary: '#589E47',
    secondary: '#75D05E'
  },
  [EMarketingCenterColorSchemes.AQUAMARINE]: {
    primary: '#33CDF0',
    secondary: '#30C3E4'
  },
  [EMarketingCenterColorSchemes.PURPLE]: {
    primary: '#9CA6FF',
    secondary: '#8A96FF'
  },
  [EMarketingCenterColorSchemes.PINK]: {
    primary: '#FF9CFB',
    secondary: '#E176F2'
  },
  [EMarketingCenterColorSchemes.ORANGE]: {
    primary: '#F1946C',
    secondary: '#E3794C'
  },
  [EMarketingCenterColorSchemes.BLACK]: {
    primary: '#405F7A',
    secondary: '#10222D'
  }
};
